import { IImageSectionEntry } from '../../../../contentful/types/IImageSectionEntry';
import { ResponsivePicture } from '../../../../ui';
import { Section, SectionHeader } from './Section';

export interface IImageSectionProps {
	id: string;
	section: IImageSectionEntry;
}

export function ImageSection({ id, section }: IImageSectionProps) {
	return (
		<Section id={id}>
			{section.fields.title && (
				<SectionHeader styling="h4">{section.fields.title}</SectionHeader>
			)}
			<ResponsivePicture
				alt={section.fields.image?.fields.description ?? 'image'}
				rounded
				noMaxWidth
				source={section.fields.image?.fields.file.url}
			/>
		</Section>
	);
}
